import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import actions from './actions'

// api
import {
    // list report
    getListReportsUserCanView,
    getListReportsByTier,

    // history
    getListUserReport,

    // current report
    createReport,
    updateReport,
    deleteReport,
    getReportById,
    sendReport,
    updateReportStatus,
    updateReadedReport,

    // select comment, media, object, event, related
    getCommentsInReport,
    createCommentInReport,
    updateCommentInReport,
    deleteCommentInReport,
    getListMediasByArray,
    getListObjectsByArray,
    getListEventsByArray,
    getListRelatedsByFid,
} from '../../services/apis/MultitierServices'
import {
    getUserById,
    getUserByArray,
} from '../../services/apis/UserAPIServices'

// notice
import { message } from 'antd'

// list report tab
function* saga_LoadListReport(action) {
    try {
        const { params } = action.payload

        let page_number = yield select(state => state.qbreport.pageIndex)
        let page_size = yield select(state => state.qbreport.pageSize)
        let status = 'Existed'
        let textSearch = yield select(state => state.qbreport.lastTextSearch)
        let tier_id = yield select(state => state.qbreport.tier_select)
        let begin_time = yield select(state => state.qbreport.begin_time)
        let end_time = yield select(state => state.qbreport.end_time)

        let user_id = yield select(state => state.auth.userInfo.uid)

        if (params.page_number) page_number = params.page_number
        if (params.page_size) page_size = params.page_size
        if (params.status) status = params.status
        if (params.tier_id) tier_id = params.tier_id
        if (params.textSearch) textSearch = params.textSearch
        if (params.begin_time) begin_time = params.begin_time
        if (params.end_time) end_time = params.end_time

        let response = ''

        if (tier_id < 1 || tier_id > 3)
            response = yield call(
                getListReportsUserCanView,
                user_id,
                page_number,
                page_size,
                status,
                encodeURIComponent(textSearch),
                begin_time,
                end_time
            )
        else
            response = yield call(
                getListReportsByTier,
                tier_id,
                page_number,
                page_size,
                status,
                encodeURIComponent(textSearch),
                begin_time,
                end_time
            )

        if (response.error.code === 200 || response.error.code === 309) {
            let reports = response.data
            let total = response.total

            if (reports.length > page_size)
                reports = reports.slice(0, page_size)

            yield put(actions.action.loadListReportSuccess(reports))
            yield put(
                actions.action.updateState({
                    total,
                })
            )
        } else {
            console.log(
                'Report - Load list report call API error ',
                response.error.message
            )
            yield put(
                actions.action.updateState({
                    reports: [],
                    total: 0,
                })
            )
        }
    } catch (ex) {
        console.log('Report - Load list report error : ', ex.message)
    }
}

function* saga_UserChageSelectTier(action) {
    try {
        const { tier } = action.payload
        yield put(
            actions.action.loadListReport({ tier_id: tier, pageIndex: 1 })
        )
    } catch (ex) {
        console.log('Report - User change select tier error: ', ex.message)
    }
}

function* saga_SearchReport(action) {
    try {
        let textSearch = yield select(state => state.qbreport.textSearch)
        yield put(actions.action.loadListReport({ textSearch }))
    } catch (ex) {
        console.log('Report - Search Report error : ', ex.message)
    }
}

function* saga_UpdatePageSize(action) {
    try {
        let { pageSize } = action.payload
        yield put(
            actions.action.loadListReport({
                page_size: pageSize,
                page_number: 1,
            })
        )
    } catch (ex) {
        console.log('Report - Update page size error : ', ex.message)
    }
}

function* saga_UpdatePageIndex(action) {
    try {
        let { pageIndex } = action.payload
        yield put(
            actions.action.loadListReport({
                page_number: pageIndex,
            })
        )
    } catch (ex) {
        console.log('Report - Update page Index error : ', ex.message)
    }
}

function* saga_UpdateTime(action) {
    try {
        let { begin_time, end_time } = action.payload
        yield put(
            actions.action.loadListReport({
                begin_time,
                end_time,
            })
        )
    } catch (ex) {
        console.log('Report - Update time : ', ex.message)
    }
}

// history tab
function* saga_LoadListHistoryReport(action) {
    try {
        const { params } = action.payload

        let page_number = yield select(
            state => state.qbreport.history_pageIndex
        )
        let page_size = yield select(state => state.qbreport.history_pageSize)
        let status = yield select(state => state.qbreport.history_status)
        let textSearch = yield select(
            state => state.qbreport.history_lastTextSearch
        )
        let begin_time = yield select(
            state => state.qbreport.history_begin_time
        )
        let end_time = yield select(state => state.qbreport.history_end_time)

        let user_id = yield select(state => state.auth.userInfo.uid)

        if (params.page_number) page_number = params.page_number
        if (params.page_size) page_size = params.page_size
        if (params.status) status = params.status
        if (params.textSearch) textSearch = params.textSearch
        if (params.begin_time) begin_time = params.begin_time
        if (params.end_time) end_time = params.end_time

        // call api
        let response = ''

        response = yield call(
            getListUserReport,
            user_id,
            page_number,
            page_size,
            status,
            textSearch,
            begin_time,
            end_time
        )

        if (response.error.code === 200 || response.error.code === 309) {
            let reports = response.data
            let total = response.total

            if (reports.length > page_size)
                reports = reports.slice(0, page_size)

            yield put(actions.action.loadListHistoryReportsSucess(reports))
            yield put(
                actions.action.updateState({
                    history_total: total,
                })
            )
        } else {
            console.log(
                'Report - Load list report call API error ',
                response.error.message
            )
            yield put(
                actions.action.updateState({
                    history_reports: [],
                    history_total: 0,
                })
            )
        }
    } catch (ex) {
        console.log('Report - Load list history report', ex.message)
    }
}

function* saga_SearchHistoryReport(action) {
    try {
        let textSearch = yield select(
            state => state.qbreport.history_textSearch
        )
        yield put(actions.action.loadListHistoryReports({ textSearch }))
    } catch (ex) {
        console.log('Report - Search history report ', ex.message)
    }
}

function* saga_UpdateHistoryTime(action) {
    try {
        let { begin_time, end_time } = action.payload
        yield put(
            actions.action.loadListHistoryReports({ begin_time, end_time })
        )
    } catch (ex) {
        console.log('Report - Update history time ', ex.message)
    }
}

function* saga_UpdateHistoryPageSize(action) {
    try {
        let { pageSize } = action.payload
        yield put(
            actions.action.loadListHistoryReports({
                page_number: 1,
                page_size: pageSize,
            })
        )
    } catch (ex) {
        console.log('Update history page size : ', ex.message)
    }
}

function* saga_UpdateHistoryPageIndex(action) {
    try {
        let { pageIndex } = action.payload
        yield put(
            actions.action.loadListHistoryReports({
                page_number: pageIndex,
            })
        )
    } catch (ex) {
        console.log('Update history page index : ', ex.message)
    }
}

function* saga_UserChangeHistorySelectStatus(action) {
    try {
        const { status } = action.payload
        yield put(
            actions.action.loadListHistoryReports({ status, pageIndex: 1 })
        )
    } catch (ex) {
        console.log('User change history select status ', ex.message)
    }
}

// report info
function* saga_SetCurrentReport(action) {
    try {
        let { report } = action.payload

        // update readed report
        yield call(updateReadedReport, report.fid)

        yield put(actions.action.loadListSelectedMedia(report.media))
        yield put(actions.action.loadListSelectedObject(report.object))
        yield put(actions.action.loadListSelectedEvent(report.event))
        yield put(actions.action.loadListSelectedReport(report.fid))
        yield put(actions.action.updateState({ hashtag: report.hashtag }))

        let userInfo = yield select(state => state.auth.userInfo)

        // get owner
        let response = yield getUserById(report.owner_id)
        if (response.error.code === 200) {
            let owner = response.data
            let uid_has_read = report.uid_has_read

            if (!uid_has_read.includes(userInfo.uid))
                uid_has_read = [...uid_has_read, userInfo.uid]

            report = {
                ...report,
                ...{
                    owner,
                    uid_has_read,
                },
            }

            yield put(actions.action.updateState({ current_report: report }))
        } else
            console.log(
                'Set current report - get report by id call API error : ',
                response.error.message
            )

        // get user sent
        response = yield getUserByArray(report.uid_has_read)
        if (response.error.code === 200 || response.error.code === 309) {
            let user_has_read = response.data
            report = {
                ...report,
                ...{
                    user_has_read,
                },
            }

            yield put(actions.action.updateState({ current_report: report }))
        } else
            console.log(
                'Set current report - get user by array call API error : ',
                response.error.message
            )

        // get list comment
        response = yield getCommentsInReport(report.fid)
        if (response.error.code === 200 || response.error.code === 309) {
            let comments = response.data

            yield put(actions.action.updateState({ comments: comments }))
        } else
            console.log(
                'Set current report - get user by array call API error : ',
                response.error.message
            )
    } catch (ex) {
        console.log('Set current report error : ', ex.message)
    }
}

function* saga_SaveCurrentReport() {
    try {
        let current_report = yield select(
            state => state.qbreport.current_report
        )
        const selected_Media = yield select(
            state => state.qbreport.selected_Media
        )
        const selected_object = yield select(
            state => state.qbreport.selected_object
        )
        const selected_event = yield select(
            state => state.qbreport.selected_event
        )
        const selected_report = yield select(
            state => state.qbreport.selected_report
        )
        const hashtag = yield select(state => state.qbreport.hashtag)
        const owner_id = yield select(state => state.auth.userInfo.uid)
        let tier_id = yield select(
            state => state.qbreport.current_report.tier_created
        )

        // update select to object
        let media = []
        for (let index = 0; index < selected_Media.length; index++)
            media.push(selected_Media[index].media_id)

        let object = []
        for (let index = 0; index < selected_object.length; index++)
            object.push(selected_object[index].object_id)

        let event = []
        for (let index = 0; index < selected_event.length; index++)
            event.push(selected_event[index].event_id)

        let related_data_id = []
        for (let index = 0; index < selected_report.length; index++)
            related_data_id.push(selected_report[index].fid)

        current_report = {
            ...current_report,
            ...{
                media,
                object,
                event,
                related_data_id,
                hashtag,
            },
        }

        // put to server
        let response = ''
        if (current_report.fid === 0) {
            // create report
            current_report = {
                ...current_report,
                ...{
                    owner_id,
                },
            }
            response = yield call(createReport, tier_id, current_report)
        } else {
            //update report
            response = yield call(
                updateReport,
                current_report.fid,
                current_report
            )
        }

        if (response.error.code === 200) {
            if (current_report.fid === 0)
                message.success('Thêm báo cáo thành công')
            else message.success('Cập nhật báo cáo thành công')

            yield put(actions.action.loadListHistoryReports({}))
            yield put(actions.action.loadListReport({}))
        } else {
            console.log(
                'Save current report call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.log('Save current report error', ex.message)
    }
}

function* saga_AddComment(action) {
    try {
        let { comment } = action.payload
        let report = yield select(state => state.qbreport.current_report)

        let response = yield call(createCommentInReport, report.fid, comment)

        if (response.error.code === 200) {
            response = yield getCommentsInReport(report.fid)
            if (response.error.code === 200 || response.error.code === 309) {
                let comments = response.data

                yield put(actions.action.updateState({ comments: comments }))
            } else
                console.log(
                    'Add Comment - get user by array call API error : ',
                    response.error.message
                )

            // load report
            yield put(actions.action.loadListHistoryReports({}))
            yield put(actions.action.loadListReport({}))
        } else
            console.log('Add comment call API error : ', response.error.message)
    } catch (ex) {
        console.log('Add comment error : ', ex.message)
    }
}

// select media
function* saga_LoadListSelectedMedia(action) {
    try {
        const { medias_id } = action.payload
        const response = yield call(getListMediasByArray, medias_id)

        if (response.error.code === 200 || response.error.code === 309) {
            let medias = response.data
            yield put(
                actions.action.updateState({
                    selected_Media: medias,
                })
            )
        } else {
            console.log(
                'Load list selected media call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.log('Load list selected media error : ', ex.message)
    }
}

// select object
function* saga_LoadListSelectedObject(action) {
    try {
        const { objects_id } = action.payload
        const response = yield call(getListObjectsByArray, objects_id)

        if (response.error.code === 200 || response.error.code === 309) {
            let objects = response.data
            yield put(
                actions.action.updateState({
                    selected_object: objects,
                })
            )
        } else {
            console.log(
                'Load list selected object call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.log('Load list selected object error : ', ex.message)
    }
}

// select event
function* saga_LoadListSelectedEvent(action) {
    try {
        const { events_id } = action.payload
        const response = yield call(getListEventsByArray, events_id)

        if (response.error.code === 200 || response.error.code === 309) {
            let events = response.data
            yield put(
                actions.action.updateState({
                    selected_event: events,
                })
            )
        } else {
            console.log(
                'Load list selected event call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.log('Load list selected event error : ', ex.message)
    }
}

// select report
function* saga_LoadListSelectedReport(action) {
    try {
        const { fid } = action.payload
        const response = yield call(getListRelatedsByFid, fid)

        if (response.error.code === 200 || response.error.code === 309) {
            let reports = response.data
            yield put(
                actions.action.updateState({
                    selected_report: reports,
                })
            )
        } else {
            console.log(
                'Load list selected report call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.log('Load list selected report error : ', ex.message)
    }
}
function* saga_getReportById(action) {
    try {
        const { id } = action.payload
        let request = yield call(getReportById, id)
        if (request.error.code === 200) {
            yield put(actions.action.setCurrentReport(request.data))
            yield put(actions.action.showModalReportInfo())
        }
    } catch (e) {
        console.log('get report by id error')
    }
}

// send report
function* saga_SendCurrentReport() {
    try {
        let report = yield select(state => state.qbreport.current_report)

        if (report.fid === 0) {
            const selected_Media = yield select(
                state => state.qbreport.selected_Media
            )
            const selected_object = yield select(
                state => state.qbreport.selected_object
            )
            const selected_event = yield select(
                state => state.qbreport.selected_event
            )
            const selected_report = yield select(
                state => state.qbreport.selected_report
            )
            const hashtag = yield select(state => state.qbreport.hashtag)
            const owner_id = yield select(state => state.auth.userInfo.uid)
            let tier_id = yield select(
                state => state.qbreport.current_report.tier_created
            )

            // update select to object
            let media = []
            for (let index = 0; index < selected_Media.length; index++)
                media.push(selected_Media[index].media_id)

            let object = []
            for (let index = 0; index < selected_object.length; index++)
                object.push(selected_object[index].object_id)

            let event = []
            for (let index = 0; index < selected_event.length; index++)
                event.push(selected_event[index].event_id)

            let related_data_id = []
            for (let index = 0; index < selected_report.length; index++)
                related_data_id.push(selected_report[index].fid)

            report = {
                ...report,
                ...{
                    media,
                    object,
                    event,
                    related_data_id,
                    hashtag,
                },
            }

            // put to server
            let response = ''
            report = {
                ...report,
                ...{
                    owner_id,
                },
            }
            response = yield call(createReport, tier_id, report)

            // send report
            if (response.error.code === 200) {
                const fid = response.data
                response = yield call(sendReport, fid)

                if (response.error.code === 200) {
                    message.success('Tạo và gửi báo cáo thành công')
                }
            } else {
                message.error('Gửi báo cáo thất bại')
            }
        } else {
            const response = yield call(sendReport, report.fid)

            if (response.error.code === 200) {
                message.success('Gửi báo cáo thành công')
            } else {
                console.log(
                    'Send current report call API error : ',
                    response.error.message
                )
                message.error('Gửi báo cáo thất bại')
            }
        }

        yield put(actions.action.loadListHistoryReports({}))
    } catch (ex) {
        console.log('Send current report error: ', ex.message)
    }
}

function* listen() {
    // list report tab
    yield takeEvery(actions.type.LOAD_LIST_REPORTS, saga_LoadListReport)
    yield takeEvery(
        actions.type.USER_CHANGE_SELECT_TIER,
        saga_UserChageSelectTier
    )
    yield takeEvery(actions.type.SEARCH_REPORT, saga_SearchReport)
    yield takeEvery(actions.type.UPDATE_PAGE_SIZE, saga_UpdatePageSize)
    yield takeEvery(actions.type.UPDATE_PAGE_INDEX, saga_UpdatePageIndex)
    yield takeEvery(actions.type.UPDATE_TIME, saga_UpdateTime)

    // history tab
    yield takeEvery(
        actions.type.LOAD_LIST_HISTORY_REPORTS,
        saga_LoadListHistoryReport
    )
    yield takeEvery(
        actions.type.SEARCH_HISTORY_REPORT,
        saga_SearchHistoryReport
    )
    yield takeEvery(actions.type.UPDATE_HISTORY_TIME, saga_UpdateHistoryTime)
    yield takeEvery(
        actions.type.UPDATE_HISTORY_PAGE_SIZE,
        saga_UpdateHistoryPageSize
    )
    yield takeEvery(
        actions.type.UPDATE_HISTORY_PAGE_INDEX,
        saga_UpdateHistoryPageIndex
    )
    yield takeEvery(
        actions.type.USER_CHANGE_HISTORY_SELECT_STATUS,
        saga_UserChangeHistorySelectStatus
    )

    // current report info
    yield takeEvery(actions.type.SET_CURRENT_REPORT, saga_SetCurrentReport)
    yield takeEvery(actions.type.SAVE_CURRENT_REPORT, saga_SaveCurrentReport)

    // comment
    yield takeEvery(actions.type.ADD_COMMENT, saga_AddComment)

    // select media
    yield takeEvery(
        actions.type.LOAD_LIST_SELECTED_MEDIA,
        saga_LoadListSelectedMedia
    )
    yield takeEvery(actions.type.GET_REPORT_BY_ID, saga_getReportById)

    // select object
    yield takeEvery(
        actions.type.LOAD_LIST_SELECTED_OBJECT,
        saga_LoadListSelectedObject
    )

    // select event
    yield takeEvery(
        actions.type.LOAD_LIST_SELECTED_EVENT,
        saga_LoadListSelectedEvent
    )

    // select
    yield takeEvery(
        actions.type.LOAD_LIST_SELECTED_REPORT,
        saga_LoadListSelectedReport
    )

    // send report
    yield takeEvery(actions.type.SEND_CURRENT_REPORT, saga_SendCurrentReport)
}

export default function* ReportSaga() {
    yield all([fork(listen)])
}
